module.exports = function() {
  return new Worker(__webpack_public_path__ + "0abef797ec1fbe5c14ee.worker.js");
};